module.exports = __webpack_public_path__ + "static/media/pic-girl.66e6eda6.svg";